/*
*+------------------------------------------------------------------------+
*| Licensed Materials - Property of IBM
*| IBM Cognos Products: BI Dashboard
*| (C) Copyright IBM Corp. 2020
*|
*| US Government Users Restricted Rights - Use, duplication or disclosure
*| restricted by GSA ADP Schedule Contract with IBM Corp.
*+------------------------------------------------------------------------+
*/

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	const FILL_STR = 'fill-';

	/**
	 * Upgrade created as a result of defect:
	 * https://jsw.ibm.com/browse/CADBC-559
	 **/

	class CssAndFillColorConflictUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1801;
		}

		/**
		* Perform upgrade
		*
		* @param {object} spec - spec to perform upgrade on
		*
		*/
		up(spec) {
			if (this._needsUpgrade(spec)) {
				return Promise.resolve(this._upgrade(spec));
			} else {
				return Promise.resolve(spec);
			}
		}

		_needsUpgrade({ layout }) {
			const { fillColor, css } = layout;
			if (!fillColor || !css) {
				// no css or no fillColor, means the colors are no in conflict
				return false;
			}

			return css.split(' ').findIndex((cssClass) => cssClass.startsWith(FILL_STR)) !== -1;
		}

		_upgrade({ layout, ...other }) {

			const { css } = layout;

			const newCss = [];

			const cssClasses = css.split(' ');

			// in case for some reason there are already multiple fill-colorX classes
			const cssIndexes = [];
			cssClasses.forEach((cssClass, index) => {
				if (cssClass.startsWith(FILL_STR)) {
					cssIndexes.push(index);
				} else {
					newCss.push(cssClass);
				}
			});

			// derive fillColor from the first fill-colorX class
			const firstCss = cssClasses[cssIndexes[0]];
			const newFillColor = firstCss.substr(FILL_STR.length);

			return {
				...other,
				layout: {
					...layout,
					fillColor: newFillColor,
					css: newCss.join(' ')
				}
			};
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

	}
	return new CssAndFillColorConflictUpgrade();
});
